import { useEffect } from 'react'
import ContactImgBox from 'src/@core/components/local-android/contact-img-box'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'src/utils/i18n'
import { setCurrentTab } from 'src/store/apps/Common'
import { useAndroidLocalImageList } from 'src/hooks/useAndroidLocalImageList'
import ContentLoading from 'src/components/ContentLoading'

const Telegram = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation('common')
  const { imgData, loading, initialLoading, setDateRange, scrollContainerRef } = useAndroidLocalImageList({
    category: 'TELEGRAM_SCREENSHOT',
    limit: 30
  })

  useEffect(() => {
    const title = t('Telegram')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      {initialLoading ? (
        <div className='relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] h-[calc(var(--vh2)*100-90px)] w-full flex'>
          <ContentLoading />
        </div>
      ) : (
        <ContactImgBox imgData={imgData} loading={loading} onDateRangeChange={setDateRange} scrollContainerRef={scrollContainerRef} />
      )}
    </>
  )
}

export default Telegram
